module.exports = __webpack_public_path__ + "lp/img/movie_box_sp@2x.3741762d.png";